import React from 'react';
import Header from '../component/Header'
import Footer from '../component/Footer';
import '../scss/error-page.scss' 
import FiveZeroZeroErrorSection from '../component/FiveZeroZeroErrorSection';
function FiveZeroZeroError() {

  return (
    <>
        <Header />       
      <main className='main error-page'>
          <div className='error-page-box'>
          <FiveZeroZeroErrorSection /> 
          </div>
        </main>
      <Footer />
    </>
  )
}
export default FiveZeroZeroError 


